export default __webpack_public_path__ + "static/media/All_v3.30172ec5.gif";